import S from 'constants/string.const';
import fromAnyToString from 'utils/converters/fromAnyToString';
import logger from 'utils/logger.util';

const L = logger('fromAnyToCoinStr');

const FRACTION_DIGITS = 2;

const fromAnyToCoinStr = (value) => {
  try {
    if (value === null || void 1 === value || value === S.empty || Number.isNaN(value)) {
      return S.empty;
    }

    if (Array.isArray(value) || Infinity === value || -Infinity === value) {
      return S.empty;
    }

    if (Number.isFinite(value)) {
      return value.toFixed(FRACTION_DIGITS);
    }

    const float = Number.parseFloat(fromAnyToString(value));

    if (Number.isFinite(float)) {
      return float.toFixed(FRACTION_DIGITS);
    }

    return S.empty;
  } catch (e) {
    L.warn('()', e, 'for value:', value);
    return S.empty;
  }
};

// noinspection JSUnusedGlobalSymbols
export default fromAnyToCoinStr;
